'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var OOP = require('utils/oop');
var Validator = require('utils/validation');

var MailboxesView = OOP.extend(AbstractFormView, {
    template: require('components/profile/templates/mailbox_dialog'),

    templateHelpers: function () {
        return {
            title: this.getOption('title'),
            name: this.getOption('name'),
        };
    },

    ui: {
        name: '#js-name-input',
        delete: '.js-delete',
        target: '.js-target',
        newTarget: 'input.js-add-target',
        save: '#js-btn-save',
        termsCheckBox: '#js-privacy-input',
    },

    events: {
        'change @ui.name': 'editName',
        'click button.js-delete': 'deleteTarget',
        'change @ui.target': 'changeTargetList',
        'keyup @ui.target': 'changeTargetList',
        'click button.js-add-target': 'changeTargetList',
        'click @ui.save': 'saveList',
        'click @ui.termsCheckBox': 'acceptTerms',
    },

    initialize: function (options) {
        this.targets = this.model ? this.model.get('targets') || [] : [];

        this.save_cb = options.save_cb;

        this.newEntry = options.name === undefined;
        this.termsAccepted = false;

        return this.base.initialize({
            inputFields: {
                'js-name': {},
                'js-privacy': { method: 'checkbox' },
            },
        });
    },

    serializeData: function () {
        return {
            targetList: this.targets,
            termsAccepted: this.termsAccepted,
        };
    },

    editName: function () {
        this.options.name = this.ui.name.val();
    },

    changeTargetList: function (e) {
        if (e.type === 'keyup' && e.keyCode != 13) {
            return;
        }

        // wait some milliseconds for possible delete event to process
        setTimeout(
            function () {
                var isOK = this.updateTargetList(e);
                this.render();

                for (var idx = 0; idx < this.targets.length; idx++) {
                    if (
                        $('#js-target-' + idx + '-input')
                            .val()
                            .trim() != ''
                    ) {
                        this.updateInputFields('js-target-' + idx, { method: Validator.validateEmailOrPhone });
                    }
                }
                this.ui.newTarget.focus();

                if (!isOK) {
                    Decorator.flash(this.ui.newTarget);
                    this.ui.newTarget.val(this.invalidTargets.join(';'));
                }
            }.bind(this),
            200
        );
    },

    updateTargetList: function (e) {
        var allTargetsOk = true;

        var newTargetList = [];
        var invalidTargetList = [];

        // process target list (ui)
        _.each(
            this.ui.target,
            function (target, index) {
                // might contain multiple (pasted) values
                var targetValues = $(target).val().toLowerCase().split(/[,;]/);

                _.each(
                    targetValues,
                    function (targetValue) {
                        targetValue = targetValue.trim();

                        // already in list? (duplicate)
                        if (_.indexOf(newTargetList, targetValue) != -1) {
                            allTargetsOk = false;
                        } else {
                            // target valid?
                            if (Validator.validateEmailOrPhone(targetValue).length === 0) {
                                // .. yes! -> save
                                newTargetList.push(targetValue);
                            } else {
                                // .. no! -> save in invalid list
                                if (targetValue !== '') {
                                    invalidTargetList.push(targetValue);
                                    allTargetsOk = false;
                                }
                            }
                        }
                    },
                    this
                );
            },
            this
        );

        // update target lists
        this.targets = newTargetList;
        this.invalidTargets = invalidTargetList;

        // any change? -> force to re-accept the terms
        if (e.type === 'keyup') {
            this.termsAccepted = false;
        }

        return allTargetsOk;
    },

    deleteTarget: function (e) {
        var index = e.currentTarget.id.split('-')[2];
        this.targets.splice(index, 1);

        this.render();
        this.ui.newTarget.focus();
    },

    saveList: function (e) {
        var inputFieldOK = this.updateTargetList(e);
        if (this.allFieldsValid() && inputFieldOK) {
            var name = this.ui.name.val();

            if (this.model) {
                this.model.set('targets', this.targets);
                this.model.set('name', name);
            }
            this.save_cb({
                name: name,
                targets: this.targets,
            });
        }

        if (!inputFieldOK) {
            Decorator.flash($(this.ui.newTarget));
        }
    },

    acceptTerms: function () {
        $('#js-terms-text').removeClass('box-color-info');
        $('#js-terms-text').removeClass('box-color-success');

        this.termsAccepted = this.ui.termsCheckBox.prop('checked');
        $('#js-terms-text').addClass('box-color-' + (this.termsAccepted ? 'success' : 'info'));
    },
});

module.exports = MailboxesView;
